import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { TagService } from './tag.service';
import { Tag } from '../models/tag.model';
import { TagCategory } from '../models/tag-category.model';
import { Instructor } from '../models/instructor.model';
import { Course } from '../models/course.model';
import { Observable } from 'rxjs/Observable';
import * as Rx from 'rxjs';


let contacts = [
  { id: 87, name: 'Pascal Precht', twitter: '@PascalPrecht' },
  { id: 2, name: 'Christoph Burgdorf', twitter: '@cburgdorf' },
  { id: 3, name: 'Thomas Burleson', twitter: '@thomasburleson' },
  { id: 4, name: 'Dominic Elm', twitter: '@elmd_' }
];

@Injectable()
export class CourseService {

    constructor(
        private dataService: ApiService,
        private tagService: TagService
    ) {}

    courseNodeName: string = 'CRS';
    tagNodeName: string = 'TAG';
    instructorNodeName: string = 'EMP';
    returnJSON;

    public populatedCourses: Array<Course> = new Array<Course>();
    private populatedCoursesForSorting: Array<Course> = new Array<Course>();

    populateCourses(res): void{
        if(!this.populatedCourses.length){

            //console.log('tags',this.tagService.populatedTagCategories);
                
            let courseData: Array<any> = res[this.courseNodeName];

            // loop through json object of course data
            courseData.forEach((courseObj, i, array) => {
                let course = new Course();
                course.title = courseObj.ShortName;
                course.id = Number(courseObj.aaapkCourseID);
                course.shortDescription = courseObj.CourseDescriptionShort;
                course.longDescription = courseObj.CourseDescriptionLong;
                course.courseNumber = courseObj.CourseNumber;       
                course.listingImage = courseObj.ImageListingFileName;   
                course.headerImage = "url('/assets/images/" + courseObj.ImageHeaderFileName + "')";   
                course.credits = courseObj.CreditHoursPossible;   
                course.gallery = courseObj.GalleryImagesForWebApp;   
                course.prereqText = courseObj.PrereqExplanation; 
                
                let tagIDArray = JSON.parse(courseObj["TagsForWebApp"]);                    

                // loop through each tag item, find associated tag and attach data
                let tagArray = new Array<Tag>();

                tagIDArray.forEach((tagID, j, array) => {                      
                    this.tagService.populatedTagCategories.forEach((tagCat, i, array) => {
                        let tagObj = tagCat.tags.find(el => el.id == tagID);
                        if(tagObj){
                            tagArray.push(tagObj);
                        }
                    });

                    course.tags = tagArray;
                });


                let instructorIDArray =  JSON.parse(courseObj["InstructorsForWebApp"]);
                
                // loop through each instructor item, find associated instructor and attach data
                let instructorArray = new Array<Instructor>();

                instructorIDArray.forEach((instructorID, j, array) => {
                    let instructor = new Instructor();                           
                    let newObject = res[this.instructorNodeName].find(el => el.aaapkEmployeeHRID == instructorID);
                    if(newObject){  
                        instructor.title = newObject.TitleLong;
                        instructor.id = Number(newObject.aaapkEmployeeHRID);
                        instructor.name = newObject.NameFull_fnf;
                        instructor.image = newObject.InstructorImageFilename;
                        instructor.url = newObject.InstructorURL;
                        instructorArray.push(instructor);
                    }
                });

                course.instructors = instructorArray;   

                let prereqIDArray =  JSON.parse(courseObj["PrereqsRequiredForWebApp"]); 

                
                // loop through each prereq item, find associated course and attach data
                let prereqArray = new Array<Course>();

                prereqIDArray.forEach((courseID, j, array) => {
                    let prereqCourse = new Course();
                    let newObject = res[this.courseNodeName].find(el => el.aaapkCourseID == courseID);  
                    if(newObject){
                        prereqCourse.title = newObject.ShortName;
                        prereqCourse.id = Number(newObject.aaapkCourseID);
                        prereqArray.push(prereqCourse);
                    }
                });

                course.prerequisites = prereqArray; 


                let recommendedIDArray =  JSON.parse(courseObj["PrereqsSuggestedForWebApp"]); 
                
                // loop through each prereq item, find associated course and attach data
                let recommendedArray = new Array<Course>();

                recommendedIDArray.forEach((courseID, j, array) => {
                    let recommendedCourse = new Course();
                    let newObject = res[this.courseNodeName].find(el => el.aaapkCourseID == courseID);  
                    if(newObject){
                        recommendedCourse.title = newObject.ShortName;
                        recommendedCourse.id = Number(newObject.aaapkCourseID);
                        recommendedArray.push(recommendedCourse);
                    }
                });

                course.recommended = recommendedArray;  

                this.populatedCoursesForSorting.push(course);  
                this.populatedCourses.push(course);
            });
        }
    }

    getSelectedCourses(): Course[] {
        this.populatedCoursesForSorting.forEach((courseObj, i, array) => {
            courseObj.relevancy = 0;
        });


        this.tagService.populatedTagCategories.forEach((tagCatObj, i, array1) => {

            // loop through the tags within the categories
            tagCatObj.tags.forEach((tagObj, j) => {

                if(tagObj.selected){

                    //console.log('tagObj',tagObj);

                    // loop through all courses
                    this.populatedCoursesForSorting.forEach((courseObj, i, array) => {


                        //console.log('courseObj',courseObj);

                        // loop through each tag item from a course, and if their is a tag that matches a selected tag, increase relevancy
                        courseObj.tags.forEach((tagItem, j, array) => {    

                            //console.log('tagItem',tagItem);                 
                            if(tagObj.id == tagItem.id && tagObj.selected == true){
                                courseObj.relevancy = courseObj.relevancy + 1;                                                           
                            }
                        });
                    });          
                }
            });            
        });

        this.populatedCoursesForSorting.sort(this.sortByRelevancyCourseNumber);
        //console.log(' this.populatedCourses', this.populatedCourses);
        return this.populatedCoursesForSorting;        
    }

    getCoursesByTag(tag:Tag): Course[]{
        let courseArray = new Array<Course>();

        // loop through all courses
        this.populatedCourses.forEach((courseObj, i, array) => {

            // loop through each tag item from a course, and if their is a tag that matches a selected tag, increase relevancy
            courseObj.tags.forEach((tagItem, j, array) => {                     
                if(tag.id == tagItem.id){
                    courseArray.push(courseObj);                                                         
                }
            });
        });          

        return courseArray;
    }

    getCourseById(id:number): Observable<any>{
        return Observable.create(observer => {
            this.getCoursesAndTags().then(res => {        
                let course = this.populatedCourses.find((course) => course.id == id);
                if(!course){
                    observer.error(new Error('course not found'));
                } else{
                    observer.next(course)
                }
                observer.complete();
            });       
        });          
    }


    getCoursesAndTags(): Promise<any> {
        return this.dataService.getData().then((res) => {
            this.tagService.populateTagCategories(res);
            this.populateCourses(res);            
        })  
    }

    toggleCourses(course: Course): void{
        this.populatedCourses.forEach((courseObj, index, array) => {     
            courseObj.courseOpen = false;
        });

        course.courseOpen = true;
    }

    sortByRelevancyCourseNumber(a: Course, b:Course): number{
        var aRelevancy = a.relevancy;
        var bRelevancy = b.relevancy;
        var aCourseNumber = a.courseNumber;
        var bCoureNumber = b.courseNumber;

        if(aRelevancy == bRelevancy){
            if(aCourseNumber == bCoureNumber){
                 return (a.title < b.title) ? -1 : 1;
            }
            else{
                return (aCourseNumber < bCoureNumber) ? -1 : (aCourseNumber > bCoureNumber) ? 1 : 0;
            }
        } else
        {
            return (bRelevancy < aRelevancy) ? -1 : 1;
        }
    }
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/services/course.service.ts